module.exports = __webpack_public_path__ + "img/Frame783@2x.0197da89.png";